import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, message, Select } from 'antd';
import axiosInstance from '../../axiosInstance';

const Units = () => {
    const [units, setUnits] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [editingUnit, setEditingUnit] = useState(null);

    useEffect(() => {
            fetchUnits();
    }, []);

    const fetchUnits = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/units');
            setUnits(response.data || []);
        } catch (error) {
            message.error('Failed to fetch units');
        } finally {
            setLoading(false);
        }
    };

    const showModal = (unit = null) => {
        if (unit) {
            form.setFieldsValue(unit);
            setEditingUnit(unit);
        } else {
            form.resetFields();
            setEditingUnit(null);
        }
        setIsModalVisible(true);
    };

    const handleOk = async (values) => {
        try {
            if (editingUnit) {
                await axiosInstance.put(`/units/${editingUnit.id}`, values);
                message.success('Unit updated');
            } else {
                await axiosInstance.post('/units', values);
                message.success('Unit added');
            }
            fetchUnits();
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            message.error('Error saving unit');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Symbol',
            dataIndex: 'symbol',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, unit) => (
                <Button onClick={() => showModal(unit)}>Edit</Button>
            ),
        },
    ];

    return (
        <div>
            <div style={{ marginBottom: 16, textAlign: 'right' }}>
                <Button type="primary" onClick={() => showModal()}>
                    Add Unit
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={units}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 25 }}
            />

            <Modal
                title={editingUnit ? 'Edit Unit' : 'Add Unit'}
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                okText={editingUnit ? 'Update' : 'Add'}
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleOk}
                >
                    <Form.Item
                        name="name"
                        label="Unit Name"
                        rules={[{ required: true, message: 'Please enter unit name' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="symbol"
                        label="Symbol"
                        rules={[{ required: true, message: 'Please enter unit symbol' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Units;
